import apiReminderChannel from "../api";

const extract = (res) => (res.status === "fulfilled" ? res.value?.data?.data || [] : []);

// Dropdown data of the channel form: the senders the builder supports (`id` = channel_key for the select).
export const loadChannelDependencies = async () => {
  const [handlersRes] = await Promise.allSettled([apiReminderChannel.getHandlers()]);
  return { handlers: extract(handlersRes).map((handler) => ({ ...handler, id: handler.channel_key })) };
};
